// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"70":"873db1231cfb8aa2","414":"35e341ad0e318dcf","5914":"6769e5ab9b3b487a","7361":"67a284ad2c60784c"}[chunkId] + ".css";
};